const pricingGroupBehaviorIds = {
    CanSetupPricingGroupRules: 'CanSetupPricingGroupRules',
    CanChooseAutoPricingGroup: 'CanChooseAutoPricingGroup',
};

export default pricingGroupBehaviorIds;
